/**
 * Generates random alphanumeric id
 * @param {number} length specifies the number of characters in the id
 * @returns alphanumeric string of size `length`
 */
export default function generateId(length = 16) {
  return (
    Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))
      .toString(36)
      .slice(1) + new Date().getTime().toString()
  );
}
